module.exports = __webpack_public_path__ + "static/media/monkey.af629d48.svg";